<template>
  <v-row class="pa-0 ma-0" align="center" justify="center">
    <v-btn v-if="checkParam()" absolute right bottom small fab color="white" @click.stop="onPrint()" class="print-btn"><v-icon>mdi-printer</v-icon></v-btn>
    <template v-if="checkParam()">
      <v-row class="ma-0" align="center" :style="contentsHeightNormal">
        <v-col cols="3" class="pa-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="3" class="pa-0">
              <v-row class="pa-0 ma-0" align="center">
                <v-col cols="12" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">{{ '（' + month +  '）' }}</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9" class="pa-0">
              <v-sheet tile color="primary" class="L-T">
                <span class="white--text">イベント</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="9" class="pa-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="12" class="pa-0">
              <v-row class="pa-0 ma-0" align="center">
                <v-col cols="4" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">タスク</span>
                  </v-sheet>
                </v-col>
                <v-col cols="1" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">担当</span>
                  </v-sheet>
                </v-col>
                <v-col cols="1" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">進捗</span>
                  </v-sheet>
                </v-col>
                <v-col cols="1" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">開始</span>
                  </v-sheet>
                </v-col>
                <v-col cols="1" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">締切</span>
                  </v-sheet>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-sheet tile color="primary" class="L-T">
                    <span class="white--text">目標</span>
                  </v-sheet>
                </v-col>
                <v-col cols="2" class="pa-0">
                  <v-sheet tile color="primary" class="L-R-T">
                    <span class="white--text">実績</span>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3" class="py-0">
          <v-flex
            d-flex
            xs12
            v-for="n in 8"
            :key="n">
            <v-row align="center">
              <v-col cols="3" class="pa-0">
                <v-row class="pa-0 ma-0" align="center">
                  <v-col cols="12" class="pa-0">
                    <v-sheet tile :color="checkToday(n) == 0 ? 'primary' : getWeekColor(getWeek(n))" :height="height" class="L-T">
                      <v-row align="center" justify="center">
                        <span :class="checkToday(n) == 0 ? 'white--text' : getWeekColorClass(getWeek(n))" :style="'padding-top: ' + ((height / 2) - ( 12 / 2) - 2) + 'px;'">{{ getDayOfMonth(n) }}</span>
                      </v-row>
                      <span :class="checkToday(n) == 0 ? 'white--text' : getWeekColorClass(getWeek(n)) + ' font-weight-bold'">{{ $WEEK[getWeek(n)] }}</span>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="9" class="pa-0">
                <v-sheet
                  tile
                  :color="getWeekColor(getWeek(n))"
                  :height="height"
                  :style="checkLines(n) + ' overflow-x: hidden;'"
                  @click.right.stop="rClick($event)"
                  class="L-T"
                >
                  <v-row align="center" justify="center" v-for="item in getEvent(n)" :key="item.key">
                    <v-col cols="12" class="py-0" align="center">
                      <p v-if="item.type == 'holiday'"
                        :style="getEventWidth(item, 1)"
                      >
                        {{ item.title }}
                      </p>
                      <p v-else
                        :style="getEventWidth(item, 1) + ' cursor: pointer;'"
                        class="mb-0"
                        @click="onEditEvent(item)"
                      >
                        {{ item.duration == 1 ? item.title : '⬇︎' + item.title }}
                      </p>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-flex>
        </v-col>
        <v-col cols="9" class="pa-0">
          <v-row class="pa-0 ma-0" align="center">
            <v-col cols="12" class="pa-0">
              <v-flex
                d-flex
                xs12
                v-for="n in 8"
                :key="n">
                <v-row align="center" justify="start" class="ma-0">
                  <v-col cols="12" class="pa-0">
                    <v-sheet
                      tile
                      :color="getWeekColor(getWeek(n))"
                      :height="height"
                      @dragover="dragover($event, n)"
                      @dragenter="dragenter($event, n)"
                      @drop="drop($event,0)"
                      @dragleave="dragleave($event)"
                      @click.right.stop="rClick($event)"
                      style="overflow-x: hidden;"
                      class="T scroll-y"
                    >
                      <v-sheet v-for="item in getTaskInCharge(n)" :key="item.key + 'sheet'"
                        draggable="true"
                        @dragstart="dragstart($event, item)"
                        @dragend="dragend($event)"
                        style="cursor: pointer; width: 100%;"
                        color="transparent"
                        @click="onEditEvent(item)"
                        >
                        <v-row align="center" justify="start" class="ma-0 pa-0" :key="item.key">
                          <v-col cols="4" class="pa-0">
                            <v-row class="ma-0" align="center" justify="center" :key="item.key">
                              <v-col cols="12" class="pa-0" align="center">
                                <v-row align="center" justify="center" class="ma-0 pa-0">
                                  <v-col cols="1" class="pa-0" align="center">
                                    <v-icon v-if="item.tag" :color="getTagColor(item)" small>mdi-tag</v-icon>
                                  </v-col>
                                  <v-col cols="2" class="pa-0 pr-1" align="center">
                                    <p :style="getTaskColor(item)" class="task-action-tiny text-center">{{ getActionName(item) }}</p>
                                  </v-col>
                                  <v-col cols="9" class="pa-0 pr-1">
                                    <p :style="getTaskColor(item)" class="task-title-tiny">{{ item.title }}</p>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="1" class="pa-0 px-1" align="center">
                            <template-group-avatar :item="item" :size="16" :height="16"></template-group-avatar>
                          </v-col>
                          <v-col cols="1" class="pa-0 pr-1" align="center">
                            <p class="task" :style="getTaskStatusWidth(item, 0.5)">
                            <v-icon size="12" class="hidden-md-and-down" :color="getCategoryColor(item)">{{ item.status ? $TASK_STATUS[item.status - 1].icon : $TASK_STATUS[0].icon }}</v-icon>
                              <span>{{ item.status ? $TASK_STATUS[item.status - 1].name : $TASK_STATUS[0].name }}</span>
                            </p>
                          </v-col>
                          <v-col cols="1" class="pa-0 pr-1" align="center">
                            <p class="task-action text-center" :style="getTaskStatusWidth(item, 0.8)">{{ getDate(item.startDate) }}</p>
                          </v-col>
                          <v-col cols="1" class="pa-0 pr-1" align="center">
                            <p class="task-action  text-center" :style="getTaskStatusWidth(item, 0.8)">
                              <span>{{ getDate(item.endDate) }}</span>
                            </p>
                          </v-col>
                          <v-col cols="2" class="pa-0 pr-1" align="center" style="width: 200px;">
                            <v-tooltip bottom color="white">
                              <template v-slot:activator="{ on }">
                                <p v-on="on" class="task" :style="getTaskStatusWidth(item, 2)">{{ item.target }}</p>
                              </template>
                              <v-card flat color="white" class="pa-0" width="200">
                                <v-card-text class="pa-1 caption">
                                  <span>{{ '目標: ' + (item.target ? item.target : '') }}</span>
                                </v-card-text>
                              </v-card>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="2" class="pa-0" align="center" style="width: 200px;">
                            <v-tooltip bottom color="white">
                              <template v-slot:activator="{ on }">
                                <p v-on="on" class="task" :style="getTaskStatusWidth(item, 2)">{{ item.result }}</p>
                              </template>
                              <v-card flat color="white" class="pa-0" width="200">
                                <v-card-text class="pa-1 caption">
                                  <span>{{ '実績: ' + (item.result ? item.result : '') }}</span>
                                </v-card-text>
                              </v-card>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-flex>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>

    <!-- For Home View -->
    <template v-else>
      <v-row align="center" justify="center" class="ma-0">
        <v-col cols="12" class="pa-0">
          <v-select
            class="caption"
            dense
            :items='filteredTasksForToday.charges'
            v-model='charge'
            hide-details
            item-text="name"
            item-value="key"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-list
            class='pa-0 ma-0 pr-1 overflow-y-auto'
            :style="contentsHeightM30"
          >
            <v-card outlined v-for="(item, index) in filteredTasksForToday.data" :key="index + 'task'" class="my-1">
              <v-card-text class="py-1 ">
                <v-row v-ripple @click="onEditEvent(item)" :key="index + 'task'" class="customLine">
                  <v-col cols="12" class="pa-0" align="center">
                    <v-row align="center" justify="center" class="ma-0 pa-0">
                      <v-col cols="1" class="pa-0" align="center">
                        <v-icon v-if="item.tag" :color="getTagColor(item)" small>mdi-tag</v-icon>
                      </v-col>
                      <v-col cols="2" class="pa-0" align="center">
                        <p :style="getTaskColor(item)" class="task-action text-center">{{ getActionName(item) }}</p>
                      </v-col>
                      <v-col cols="9" class="pa-0">
                        <p :style="getTaskColor(item)" class="task-title">{{ item.title }}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pa-0" align="center">
                    <v-row align="center" justify="center" class="ma-0 pa-0">
                      <v-col cols="4" class="py-0 px-1" align="center">
                        <template-group-avatar :item="item" :size="16" :height="16" ></template-group-avatar>
                      </v-col>
                      <v-col cols="4" class="py-0 px-1" align="center">
                        <p class="task" :style="getTaskStatusWidth(item, 0.5)">
                          <span><v-icon size="14" :color="getCategoryColor(item)">{{ item.status ? $TASK_STATUS[item.status - 1].icon : $TASK_STATUS[0].icon }}</v-icon>
                            {{ item.status ? $TASK_STATUS[item.status - 1].name : $TASK_STATUS[0].name }}</span>
                        </p>
                      </v-col>
                      <v-col v-if="item.diff > 0" cols="4" class="py-0 px-1" align="center">
                        <p class="over">{{ MMDD(item.endDate) + ' +' + item.diff + '日' }}</p>
                      </v-col>
                      <v-col v-else cols="4" class="py-0 px-1">
                        <p class="task" :style="getChargeWidth(item)">
                          {{ MMDD(item.endDate) }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-list>
        </v-col>
      </v-row>
    </template>

    <div>
      <v-dialog v-model="taskDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-task-dialog
          v-if="taskDialog"
          @dismissed="onDismissed"
          :dialog='taskDialog'
          :item="item"
          :group="group"
          :year="year"
          :month="month"
          :events="events"
          :tasks="tasks"
          :taskTemplates="taskTemplates"
          type="new"
        >
        </app-task-dialog>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='eventDialog'
          persistent
          :max-width="'400px'">
          <app-event-edit
            v-if="eventDialog"
            @dismissed="onDismissed"
            :item="item"
            :dialog='eventDialog'
            :event="event"
          >
          </app-event-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='dialog'
          persistent
          :max-width="'400px'">
          <app-task-edit
            v-if="dialog"
            @dismissed="onDismissed"
            :item="item"
            :dialog='dialog'
            :task="task"
          >
          </app-task-edit>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Moment from 'moment-timezone'
import { extendMoment } from 'moment-range'
import TaskEditDialog from '../../components/schedule/TaskEditDialog.vue'
import TemplateGroupAvatar from '../../components/common/TemplateGroupAvatar.vue'
Vue.component('app-task-edit', TaskEditDialog)
Vue.component('template-group-avatar', TemplateGroupAvatar)
const moment = extendMoment(Moment)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      holidays: 'holidays/holidays',
      scheduleEvents: 'scheduleEvents/events',
      templateEvents: 'templateEvents/templates',
      templateTasks: 'templateTasks/templates',
      scheduleTasks: 'scheduleTasks/events',
      tags: 'tags/tags',
      windowSize: 'shared/windowSize'
    }),
    filteredEvents () {
      var temp = []
      var vm = this
      moment.tz.setDefault('Asia/Tokyo')
      for (var i = 0; i < 8; i++) {
        var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
        var base = moment(now).add(this.offset + i, 'days').format('YYYY-MM-DD')
        var events = JSON.parse(JSON.stringify(this.scheduleEvents)).filter(function (item, index) {
          if (item.startDate !== base) {
            return false
          }
          if (item.groups[`*`]) {
            return true
          }
          return item.groups[vm.group]
        })
        for (var x in events) {
          var index = this.templateEvents.findIndex(ev => ev.key === events[x].template)
          if (index !== -1) {
            events[x]['category'] = this.templateEvents[index].category
            events[x]['period'] = this.templateEvents[index].period
            events[x]['title'] = this.templateEvents[index].title
            events[x]['description'] = this.templateEvents[index].description
            events[x]['schools'] = this.templateEvents[index].schools
          }
        }
        temp[i] = events
        for (var h in this.holidays) {
          if (this.holidays[h].enable) {
            for (var y in this.holidays[h].events) {
              if (this.holidays[h].events[y].startDate === base) {
                temp[i].push(this.holidays[h].events[y])
              }
            }
          }
        }
      }
      return temp
    },
    filteredTasks () {
      var temp = []
      var vm = this
      moment.tz.setDefault('Asia/Tokyo')
      for (var i = 0; i < 8; i++) {
        var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
        var base = moment(now).add(this.offset + i, 'days').format('YYYY-MM-DD')
        var tasks = JSON.parse(JSON.stringify(this.scheduleTasks)).filter(function (item, index) {
          if (item.startDate !== base) {
            return false
          }
          if (vm.group && vm.group === '*') {
            return true
          } else if (vm.group && item.groups[vm.group]) {
            return true
          }
          return false
        })
        for (var x in tasks) {
          var index = this.templateTasks.findIndex(task => task.key === tasks[x].template)
          if (index !== -1) {
            tasks[x]['category'] = this.templateTasks[index].category
            tasks[x]['action'] = this.templateTasks[index].action
            tasks[x]['title'] = this.templateTasks[index].title
            tasks[x]['description'] = this.templateTasks[index].description
            tasks[x]['schools'] = this.templateTasks[index].schools
          }
        }
        temp[i] = tasks
      }
      return temp
    },
    filteredTasksForToday () {
      var temp = []
      var charges = []
      var vm = this
      moment.tz.setDefault('Asia/Tokyo')
      if (!this.school) {
        return false
      }
      var span = this.school.tasks ? this.school.tasks.span : 7
      temp = JSON.parse(JSON.stringify(this.scheduleTasks)).filter(function (item, index) {
        if (item.status > 3) {
          return false
        }
        if (vm.param && vm.param.group !== '*') {
          if (vm.param && !item.groups[vm.param.group]) {
            return false
          }
        }
        var start = moment(item.startDate)
        if (moment().diff(start, 'days') < 0) {
          return false
        }
        var end = moment(item.endDate)
        if (moment().diff(end, 'days') > span) {
          return false
        }
        if (vm.param.taskFilter) {
          if (vm.param.tag) {
            if (item.tag !== vm.param.tag.key) {
              return false
            }
          } else if (!item.tag) {
            return false
          }
        }
        if (vm.charge !== '*') {
          if (vm.charge === '') {
            if (item.charge !== null) {
              return false
            }
          } else if (vm.charge !== item.charge) {
            return false
          }
        }
        return vm.templateTasks.findIndex(t => t.key === item.template) !== -1
      })
      if (vm.param.dateSort) {
        temp.sort(function (a, b) {
          var aend = moment(a.endDate)
          var bend = moment(b.endDate)
          if (aend > bend) return 1
          if (aend < bend) return -1
          return 0
        })
      } else {
        temp.sort(function (a, b) {
          var aend = moment(a.endDate)
          var bend = moment(b.endDate)
          if (aend > bend) return -1
          if (aend < bend) return 1
          return 0
        })
      }
      for (var i in temp) {
        var index = this.templateTasks.findIndex(task => task.key === temp[i].template)
        if (index !== -1) {
          temp[i]['category'] = this.templateTasks[index].category
          temp[i]['action'] = this.templateTasks[index].action
          temp[i]['title'] = this.templateTasks[index].title
          temp[i]['description'] = this.templateTasks[index].description
          temp[i]['schools'] = this.templateTasks[index].schools
          var diff = moment().diff(moment(temp[i].endDate), 'days')
          temp[i]['diff'] = diff
        }

        var c = { name: this.getCharge(temp[i]), key: temp[i].charge }
        charges.push(c)
      }
      charges.sort(function (a, b) {
        if (a.name > b.name) return 1
        if (a.name < b.name) return -1
        return 0
      })
      charges.unshift({ name: '全員', key: '*' })
      return { data: temp, charges: charges }
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - (this.param.viewType ? 358 : 128) - 30 - 28 - 40) + 'px;'
    },
    contentsHeightM30 () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - (this.param.viewType ? 358 : 128) - 30 - 28 - 30 - 40) + 'px;'
    },
    contentsHeightNormal () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      loading: false,
      height: 80,
      maxline: 1,
      dialog: false,
      eventDialog: false,
      event: null,
      taskDialog: false,
      descriptions: [],
      task: null,
      y: true,
      base: null,
      item: null,
      school: null,
      menuItems: [
        { title: '種別順', value: 'category' },
        { title: '時間順', value: 'time' }
      ],
      menuSort: 'time',
      charge: '*'
    }
  },
  props: [ 'param', 'edit', 'year', 'month', 'group', 'add', 'events', 'tasks', 'offset', 'eventTemplates', 'taskTemplates', 'lines', 'type' ],
  watch: {
    add () {
      if (this.add) {
        this.item = JSON.parse(JSON.stringify(this.$store.getters['scheduleEvents/initial']))
      } else {
        this.item = null
      }
      this.taskDialog = this.add
    },
    schools () {
      this.createSchool()
    },
    windowSize () {
      this.height = (this.windowSize.y - 60 - 60 - 25 - 40) / 8
    }
  },
  created () {
    // console.log(this.contentsHeight)
    moment.tz.setDefault('Asia/Tokyo')
    if (!this.param) {
      this.wait()
    }
    this.createSchool()
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
    this.height = (this.windowSize.y - 60 - 60 - 25 - 40) / 8
  },
  methods: {
    async wait () {
      this.loading = true
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      await pause(100).then(() => {
        this.loading = false
      })
    },
    createSchool () {
      if (this.data) {
        var keys = Object.keys(this.data.schools)
        for (var i in keys) {
          if (this.data.schools[keys[i]]) {
            var index = this.schools.findIndex(school => school.key === keys[i])
            if (index !== -1) {
              this.school = this.schools[index]
            }
          }
        }
      }
    },
    checkParam () {
      var value = false
      if (typeof this.param === 'undefined') {
        return true
      }
      if (this.param && this.param.type !== 'home') {
        value = true
      }
      if (!this.param) {
        value = true
      }
      return value
    },
    dragstart (e, item) {
      this.dragitem = JSON.parse(JSON.stringify(item))
      this.dragto = null
      e.target.style.opacity = 0.5
    },
    drop (e) {
      e.target.style.opacity = 1
      var item = null
      var start = this.getDay(this.dragto.dd)
      item = JSON.parse(JSON.stringify(this.dragitem))
      item.startDate = start.format('YYYY-MM-DD')
      item.start = {
        date: start.format('YYYY-MM-DD'),
        yyyy: parseInt(start.format('YYYY')),
        mm: parseInt(start.format('MM')),
        dd: parseInt(start.format('DD'))
      }
      var end = start.add(this.dragitem.duration - 1, 'days')
      item.endDate = start.format('YYYY-MM-DD')
      item.end = {
        date: end.format('YYYY-MM-DD'),
        yyyy: parseInt(end.format('YYYY')),
        mm: parseInt(end.format('MM')),
        dd: parseInt(end.format('DD'))
      }
      if (!item.charge) {
        item.charge = this.user.uid
      }
      item.schools[this.school.key] = true
      this.storeEvent(item)
      this.dragitem = this.dragto = null
      e.stopPropagation()
      e.preventDefault()
    },
    dragend (e) {
      e.target.style.opacity = 1.0
      e.preventDefault()
      this.dragitem = this.dragto = null
    },
    dragover (e, dd) {
      e.preventDefault()
      this.dragto = { dd: dd }
    },
    dragenter (e, x, i) {
      e.preventDefault()
      e.target.style.opacity = 0.5
    },
    dragleave (e) {
      e.preventDefault()
      e.target.style.opacity = 1
    },
    getTagColor (item) {
      if (item.tag) {
        var index = this.tags.findIndex(t => t.key === item.tag)
        if (index !== -1) {
          return this.tags[index].color
        }
      }
      return 'grey'
    },
    getMonth (mm) {
      var m = mm + 3
      if (m > 13) {
        m -= 13
      }
      return m
    },
    getDayOfMonth (dd) {
      moment.tz.setDefault('Asia/Tokyo')
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      return moment(now).add(this.offset + (dd - 1), 'days').format('MM/DD')
    },
    checkToday (dd) {
      moment.tz.setDefault('Asia/Tokyo')
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      var day = moment(now).add(this.offset + (dd - 1), 'days')
      return day.diff(moment(moment().format('YYYY-MM-DD')), 'days')
    },
    getEventWidth (item, x) {
      var s = ''
      s = 'width: 90%; ' + 'height: 16px;'
      s += ' font-size: 10px; padding-left: 6px !important; padding-right: 2px !important;'
      s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      return s
    },
    getTaskColor (item) {
      const bg = 'background-color: ' + this.getDescriptionColor(item, this.$COLOR_LIGHT) + '; '
      const border = 'border: 1px solid ' + this.getDescriptionColor(item, this.$COLOR_DEFAULT) + '; '
      const font = 'color: ' + this.getDescriptionColor(item, this.$COLOR_DARK) + '; '
      return bg + border + font
    },
    getTaskStatusWidth (item, x) {
      var height = '16px;'
      var font = '11px;'
      if (!item) {
        item = { category: '' }
        height = '21px;'
        font = '12px;'
      }
      if (this.param && this.param.type === 'home') {
        height = '16px;'
        font = '11px;'
      }
      var color = this.getDescriptionColor(item)
      var s = ''
      s = 'width: 100%; ' + 'height: ' + height + 'line-height: ' + height
      s += ' font-size: ' + font
      if (item.category !== '') {
        s += ' color: ' + color + '; background-color: #FFFFFF; border: 1px solid ' + color + ';'
      } else {
        s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      }
      return s
    },
    getChargeWidth (item, x) {
      var height = '16px;'
      var font = '11px;'
      if (this.param && this.param.type === 'home') {
        height = '16px;'
        font = '11px;'
      }
      var color = this.getDescriptionColor(item)
      var s = ''
      s = 'width: 100%; ' + 'height: ' + height + '; line-height: ' + height + ';'
      s += ' font-size: ' + font
      if (item.category !== '') {
        s += ' color: ' + color + '; background-color: #FFFFFF; border: 1px solid ' + color + ';'
      } else {
        s += ' background-color: ' + this.getDescriptionColor(item) + ';'
      }
      return s
    },
    getErapsed (item) {
      var color = this.getDescriptionColor(item)
      var s = 'width: 100%; height: 16px; font-size: 11px;'
      if (item.diff > 0) {
        s += ' color: #FFFFFF; background-color: #FF5252;'
      } else {
        s += ' color: ' + color + '; background-color: #FFFFFF; border: 1px solid ' + color + ';'
      }
      return s
    },
    getEvent (dd) {
      var events = []
      var temp = JSON.parse(JSON.stringify(this.filteredEvents[dd - 1]))
      for (var i in temp) {
        if (temp[i].type === 'event') {
          if (temp[i].groups['*']) {
            events.push(temp[i])
          } else if (temp[i].groups[this.group]) {
            events.push(temp[i])
          }
        } else {
          events.push(temp[i])
        }
      }
      return events
    },
    getTask (mm, dd, category) {
      var temp = JSON.parse(JSON.stringify(this.filteredTasks[dd - 1]))
      var tasks = []
      for (var i in temp) {
        if (temp[i].category === this.$DESCRIPTIONS_ITEMS[category - 1].key && !temp[i].charge) {
          if (this.group === '*') {
            tasks.push(temp[i])
          } else if (temp[i].groups[this.group]) {
            tasks.push(temp[i])
          }
        }
      }
      return tasks
    },
    getTaskInCharge (dd) {
      var temp = JSON.parse(JSON.stringify(this.filteredTasks[dd - 1]))
      var tasks = []
      for (var i in temp) {
        if (this.group === '*') {
          tasks.push(temp[i])
        } else if (temp[i].groups[this.group]) {
          tasks.push(temp[i])
        }
      }
      return tasks
    },
    getDay (dd) {
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      return moment(now).add(this.offset + (dd - 1), 'days')
    },
    getWeek (dd) {
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      return moment(now).add(this.offset + (dd - 1), 'days').day()
    },
    getCharge (item) {
      var index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return JSON.parse(JSON.stringify(this.users[index].sei))
      }
      return ''
    },
    getDate (date) {
      return date.slice(5).replace('-', '/')
    },
    getAvatar (item) {
      var url = null
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].avatar) {
            return this.groups[index].avatar.thumbnail
          } else {
            break
          }
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            name = this.groups[index].name.slice(0, 1)
          } else {
            break
          }
        }
      }
      return name
    },
    getGroupColor (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          if (this.groups[index].name) {
            return this.groups[index].color ? this.groups[index].color : 'primary'
          }
        }
      }
      return 'primary'
    },
    checkLines (dd) {
      moment.tz.setDefault('Asia/Tokyo')
      var now = moment().startOf('isoWeek').format('YYYY-MM-DD')
      var base = moment(now).add(this.offset + (dd - 1), 'days').format('YYYY-MM-DD')
      var m = moment(base).month() < 3 ? moment(base).month() + 9 : moment(base).month() - 3
      var d = moment(base).date() - 1
      if (this.lines[m][d].length !== 0) {
        return 'border-left: 1px solid ' + this.getDescriptionColor(this.lines[m][d][0]) + ' !important;'
      }
      return ''
    },
    checkTemplateDay (x, item) {
      return this.month === item.month && x === item.week
    },
    checkMonth (item) {
      return this.month === item.month
    },
    thisMonth () {
      var m = new Date().getMonth() + 1
      return m
    },
    getType (i) {
      return this.$WEEK_ZONE_TABLE[parseInt(i) - 1].name
    },
    getActionName (item) {
      var index = this.$ACTION_TABLE.findIndex(a => a.key === item.action)
      if (index !== -1) {
        return this.$ACTION_TABLE[index].name
      }
      return 'N/A'
    },
    getGroupName (item) {
      var keys = Object.keys(item.groups)
      for (var i in keys) {
        var index = this.groups.findIndex(g => g.key === keys[i])
        if (index !== -1) {
          return this.groups[index].name
        }
      }
      return ''
    },
    rClick (e) {
      e.preventDefault()
    },
    onPrint () {
      window.print()
    },
    onMenu (item) {
      this.menuSort = item.value
    },
    onEditEvent (item) {
      if (this.type && this.type === 'dialog') {
        this.$emit('change', { item: JSON.parse(JSON.stringify(item)) })
      } else {
        this.item = JSON.parse(JSON.stringify(item))
        if (item.type === 'event') {
          this.event = 'event'
          this.eventDialog = true
        } else {
          this.task = 'task'
          this.dialog = true
        }
      }
    },
    onDismissed () {
      this.dialog = false
      this.eventDialog = false
      this.$emit('dismissed')
    },
    storeEvent (item) {
      var vm = this
      vm.loading = true
      var path = item.type === 'event' ? 'scheduleEvents/write' : 'scheduleTasks/write'
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(item))
        if (item.key) {
          payload.updatedAt = parseInt(new Date().getTime())
        } else {
          payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        }
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
        })
      })
    }
  }
}
</script>

<style scoped>

/* .v-sheet.T {
  text-align: center;
  border-top: 1px solid white !important;
}

.v-sheet.L-T {
  text-align: center;
  border-top: 1px solid white !important;
  border-left: 1px solid white !important;
}

.v-sheet.L-T-B {
  text-align: center;
  border-top: 1px solid white !important;
  border-left: 1px solid white !important;
  border-bottom: 1px solid white !important;
}

.v-sheet.L-R-T {
  text-align: center;
  border-top: 1px solid white !important;
  border-left: 1px solid white !important;
  border-right: 1px solid white !important;
}

.v-sheet.L-R-T-B {
  text-align: center;
  border-top: 1px solid white !important;
  border-left: 1px solid white !important;
  border-right: 1px solid white !important;
  border-bottom: 1px solid white !important;
} */

p.task {
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  border-radius: 0px;
  line-height: 16px;
  margin: 0px !important;
}

p.group {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 8px;
  line-height: 16px;
  text-align: center;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.over {
  color: #B71C1C;
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  background-color: #FFCDD2;
  border: 1px solid #EF5350;
  text-align: center;
  width: 100%;
  height: 16px;
  font-size: 11px !important;
  vertical-align: middle !important;
  padding: 0px !important;
  margin: 0px !important;
}

p.charge {
  white-space: nowrap;
  overflow: hidden;
  line-height: 16px;
  border-radius: 8px;
  padding: 0px;
  margin: 0px;
}

p.task-action {
  font-size: 12px !important;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  padding: 0px;
  margin: 0px;
}

p.task-title {
  font-size: 12px !important;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0px;
  color: aliceblue;
}

p.task-action-tiny {
  font-size: 11px !important;
  line-height: 16px !important;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 0px;
  padding: 0px !important;
  margin: 0px !important;
}

p.task-title-tiny {
  font-size: 11px !important;
  line-height: 16px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 0px;
  padding: 0px !important;
  padding-left: 6px !important;
  margin: 0px !important;
}

p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: aqua;
  border-radius: 8px;
  padding-left: 6px;
  margin: 2px;
  line-height: 18px;
  color: aliceblue;
  text-align: left;
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

span {
  user-select: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
}
::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.3);
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

</style>
